var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWallet(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.625 9V27C5.625 27.5967 5.86205 28.169 6.28401 28.591C6.70597 29.0129 7.27826 29.25 7.875 29.25H30.375C30.6734 29.25 30.9595 29.1315 31.1705 28.9205C31.3815 28.7095 31.5 28.4234 31.5 28.125V12.375C31.5 12.0766 31.3815 11.7905 31.1705 11.5795C30.9595 11.3685 30.6734 11.25 30.375 11.25H7.875C7.27826 11.25 6.70597 11.0129 6.28401 10.591C5.86205 10.169 5.625 9.59674 5.625 9ZM5.625 9C5.625 8.40326 5.86205 7.83097 6.28401 7.40901C6.70597 6.98705 7.27826 6.75 7.875 6.75H27",
    stroke: "#727272",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.3125 21.6562C26.0892 21.6562 26.7188 21.0267 26.7188 20.25C26.7188 19.4733 26.0892 18.8438 25.3125 18.8438C24.5358 18.8438 23.9062 19.4733 23.9062 20.25C23.9062 21.0267 24.5358 21.6562 25.3125 21.6562Z",
    fill: "#727272"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWallet);
export default __webpack_public_path__ + "static/media/wallet.92efae211895fb232dfa0b4f7a73757d.svg";
export { ForwardRef as ReactComponent };